var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{style:({
			paddingBottom: '0px',
			minHeight: '100vh',
			display: 'flex',
			flexDirection: 'column'
		})},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('notification'),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.loader.value),expression:"$root.loader.value"}],staticClass:"loader",attrs:{"src":"loader.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }